// utils/useDebounce.js
import { useEffect } from 'react';

export const useDebounce = (callback, delay, deps = []) => {
  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);

    return () => clearTimeout(handler);
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};
